import {
  AbstractControl,
  AsyncValidatorFn,
} from '@angular/forms';
import {
  Observable,
  of,
} from 'rxjs';
import { map } from 'rxjs/operators';

export class TimeDateValidator {
  getTimeDateStamp(formData) {
    return false;
  }

  searchTimeDate(formData) {
    if (!formData) { return; }

    const isInBetween = this.getTimeDateStamp(formData);

    if (isInBetween) {
      return null;
    }

    return { notInBetween: true };
  }

  validateTimeDate(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<{ [key: string]: any } | null> => (
     of(control.value).pipe(map((val) => this.searchTimeDate(val)))
    );
  }
}
